<template>
  <div class="position-relative body2">
    <!-- 抽奖容器 -->
    <div ref="container" class="draw-container">
      <div ref="names" class="names">
        <div v-for="name in displayedNames" :key="name" class="name">
          {{ name }}
        </div>
      </div>
      <div class="pointer"></div>
    </div>

    <!-- 弹框 -->
    <div class="popup" :class="{ show: showPopup }" @click="showPopup = false">
      <div class="popup-content" @click.stop>
        <img src="@/assets/images/cat.png" alt="Cat" class="popup-cat" />
        <div class="selected-name" :style="{ backgroundColor: popupColor }">
          {{ selectedName }}
        </div>
      </div>
    </div>

    <!-- 按钮组 -->
    <div class="mt-5 text-center start-btn">
      <button class="mx-2 button-c" @click="startAnimation">开始抽选</button>
      <button class="mx-2 button-c" @click="openUploadModal">导入名单</button>
    </div>

    <!-- 导入名单 Modal -->
    <div class="modal fade" id="uploadModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">导入名单</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <input
              type="file"
              accept=".xlsx"
              @change="handleFileUpload"
              class="form-control"
            />
            <p class="text-center text-muted mt-2">
              提示：请把名单写在 Excel 表的第一列，然后上传即可。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script setup>
import { ref, onMounted, onUnmounted } from "vue";
import * as XLSX from "xlsx";
import { Modal } from "bootstrap";

// 导入音频文件
import spinSoundUrl from "@/assets/sounds/spin.mp3";
import winSoundUrl from "@/assets/sounds/win.mp3";

const names = ref(null);
const container = ref(null);
const showPopup = ref(false);
const selectedName = ref("");
const popupColor = ref("");
const students = ref(
  JSON.parse(localStorage.getItem("students")) || [
    "张三",
    "李四",
    "王五",
    "赵六",
  ]
);
const displayedNames = ref([]); // 用于渲染的名字列表

const spinSound = new Audio(spinSoundUrl);
const winSound = new Audio(winSoundUrl);
let animId;

// 工具函数
function getRandomColorByProbability() {
  const r = Math.random();
  if (r < 0.8) return "blue";
  if (r < 0.9) return "pink";
  if (r < 0.98) return "red";
  return "gold";
}

function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
}

function generateNames() {
  const s = [...students.value];
  shuffle(s);
  return [...s, ...s];
}

function easeOutBack(t) {
  const c1 = 1.50158,
    c3 = c1 + 1;
  return 1 + c3 * (t - 1) ** 3 + c1 * (t - 1) ** 2;
}

function startAnimation() {
  cancelAnimationFrame(animId);
  showPopup.value = false;

  // 重置位置
  names.value.style.transition = "none";
  names.value.style.transform = "translateX(0)";

  // 播放音效
  spinSound.currentTime = 0;
  spinSound.play();

  // 生成随机名单
  const arr = generateNames();
  displayedNames.value = arr;

  // 计算容器和元素尺寸
  const cont = container.value;
  const cw = cont.offsetWidth;
  const firstChild = names.value.querySelector(".name");
  const nw = firstChild ? firstChild.offsetWidth : 128; // 默认宽度，防止初始渲染前获取不到
  const gap = 30;
  const total = arr.length;

  // 随机选择目标位置
  const idx =
    total -
    students.value.length +
    Math.floor(Math.random() * students.value.length);
  const tp = idx * (nw + gap) - (cw / 2 - nw / 2);

  // 启动动画
  const dur = 4000,
    start = Date.now();
  function animate() {
    const t = Math.min((Date.now() - start) / dur, 1);
    const e = easeOutBack(t);
    names.value.style.transform = `translateX(-${e * tp}px)`;

    if (t < 1) {
      animId = requestAnimationFrame(animate);
    } else {
      onFinish(tp);
    }
  }

  animId = requestAnimationFrame(animate);
}

function onFinish(tp) {
  winSound.currentTime = 0;
  winSound.play();

  // 确定最终位置
  names.value.style.transform = `translateX(-${tp}px)`;

  // 找到指针中间的名字
  const rect = container.value.getBoundingClientRect();
  const mid = rect.left + rect.width / 2;
  let sel = "";

  names.value.querySelectorAll(".name").forEach((el) => {
    const r = el.getBoundingClientRect();
    if (mid >= r.left && mid <= r.right) {
      sel = el.textContent;
    }
  });

  // 显示结果弹窗
  if (sel) {
    selectedName.value = sel;
    popupColor.value = getRandomColorByProbability();
    showPopup.value = true;
    document.querySelector(".popup-content").style.borderColor =
      popupColor.value;
  }
}

function openUploadModal() {
  new Modal(document.getElementById("uploadModal")).show();
}

function handleFileUpload(e) {
  const f = e.target.files[0];
  if (!f) return;

  const r = new FileReader();
  r.onload = (ev) => {
    try {
      const data = new Uint8Array(ev.target.result);
      const wb = XLSX.read(data, { type: "array" });
      const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
        header: 1,
      });

      // 提取第一列作为名字列表
      const ns = rows.map((r) => r[0]).filter(Boolean);
      if (ns.length) {
        students.value = ns;
        localStorage.setItem("students", JSON.stringify(ns));
        alert("导入成功");
      } else {
        alert("格式错误：Excel 文件中未找到有效数据");
      }
    } catch (error) {
      console.error("文件解析错误:", error);
      alert("导入失败：文件格式不正确");
    }
  };
  r.readAsArrayBuffer(f);
}

onMounted(() => {
  // 从本地存储加载学生数据
  students.value =
    JSON.parse(localStorage.getItem("students")) || students.value;
  container.value = names.value.parentElement;
});

onUnmounted(() => {
  cancelAnimationFrame(animId);
});
</script>
  
  
  <style scoped>
/* 设置黑板背景 */
.body2 {
  background-image: url("@/assets/images/blackboard.png");
  background-size: cover;
  background-position: center;
  font-family: "Comic Sans MS", cursive, sans-serif;
  height: 100vh;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* 抽奖容器：定位到黑板"红框"内 */
.draw-container {
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
  /* Use 90% on small screens, cap at 900px on larger */
  width: 90%;
  max-width: 900px;
  height: 400px;
  overflow: hidden;
}
/* 滚动名字列表 */
.names {
  position: absolute;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  gap: 30px; /* 增大名字间距 */
  padding: 0 20px;
}

/* 猫咪书签：宽128，高384；文字竖向显示 */
.name {
  flex: 0 0 auto;
  width: 128px;
  height: 384px;
  background-image: url("@/assets/images/catbookmark.png"); /* 你的猫咪书签 */
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  writing-mode: vertical-rl;
  text-orientation: upright;
  justify-content: center;
  align-items: center;
  font-size: 38px;
  color: #333;
  padding-top: 50px; /* 预留猫头区域 */
  padding-right: 10px;
  box-sizing: border-box;
}

/* 选中指示器（红色直线） */
.pointer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 5px;
  height: 400px;
  background-color: red;
  z-index: 2;
}

/* 弹框外层容器：用于居中和遮罩 */
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; /* 默认不接受点击 */
  opacity: 0;
  transition: opacity 0.5s ease-out;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.3); /* 半透明遮罩，可按需调整 */
}

/* 弹框可见时 */
.popup.show {
  opacity: 1;
  pointer-events: auto; /* 可交互 */
}

/* 弹框内容容器：带华丽动画 + 边框 + 圆角 */
.popup-content {
  position: relative;
  width: 350px; /* 猫咪图片大小，可自行调整 */
  height: 350px;
  background-color: #fff; /* 若图片非全覆盖可用纯色衬底 */
  border: 8px solid #000; /* 初始颜色，JS 动态改 */
  border-radius: 20px; /* 圆角矩形 */
  overflow: hidden; /* 超出隐藏，防止边角溢出 */
  transform: scale(0.2) translateY(200px);
  opacity: 0;
  animation: popupZoomIn 0.8s ease-out forwards;
}

/* 猫咪图片：圆角矩形 */
.popup-cat {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  display: block;
}

/* 左上角显示名字：颜色通过 JS 动态设置 */
.selected-name {
  position: absolute;
  top: 10px;
  left: 10px;
  color: #fff;
  font-size: 24px;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px 10px;
  border-radius: 10px;
  pointer-events: none; /* 避免干扰点击 */
}
.start-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  /* default for desktop */
  top: calc(50% + 210px);
}


/* Phones: nudge button up since container shrinks */
@media (max-width: 575.98px) {
  .start-btn {
    top: calc(50% + 130px);
  }
}

/* Tablets: intermediate */
@media (min-width: 576px) and (max-width: 767.98px) {
  .start-btn {
    top: calc(50% + 170px);
  }
}
.button-c {
  min-width: 8rem;
  min-height: 4rem;
  font-size: 20px;
  color: white;
  background-color: #ff6600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.button-c:hover {
  background-color: #cc5200;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

/* 弹出动画（华丽一点：先放大，再回落） */
@keyframes popupZoomIn {
  0% {
    transform: scale(0.2) translateY(200px);
    opacity: 0;
  }
  50% {
    transform: scale(1.2) translateY(-10px);
    opacity: 1;
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
</style>